/**
 * @example
 *
 * import { useFeature } from '@hackler/react-sdk';
 *
 * const { isLiveSessionFeatureOn } = useChallengeLiveSessionFeature();
 * import { CHALLENGE_LIVE_SESSION_FEATURE_KEY } from './constants/hackleFeatureKey';
 *
 *export const useChallengeLiveSessionFeature = () => {
 *  const isFeatureOn = useFeature(CHALLENGE_LIVE_SESSION_FEATURE_KEY);
 *
 *  return { isLiveSessionFeatureOn: isFeatureOn };
 * };
 */

import { useFeature } from '@hackler/react-sdk';

export const INSTRUCTOR_APPLICATION_FEATURE_KEY = 237;

export const useInstructorApplicationFeature = () => {
  const isFeatureOn = useFeature(INSTRUCTOR_APPLICATION_FEATURE_KEY);

  return { isInstructorApplicationFeatureOn: isFeatureOn };
};
